// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zDwvJTAw{margin-top:var(--space-slim)}`, "",{"version":3,"sources":["webpack://./src/page-components/save-cooperative-yield-checkbox/SaveCooperativeYieldCheckbox.module.scss"],"names":[],"mappings":"AAAA,UACE,4BAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zDwvJTAw`
};
export default ___CSS_LOADER_EXPORT___;
